import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Quote } from 'lucide-react';
const testimonials = [{
  initials: 'MR',
  name: 'Mariana R.',
  context: 'Creadora de contenido de bienestar',
  quote: 'Tenía 4K seguidores y cero ingresos. Apliqué el Motor 3-Loop y en 3 semanas cerré mis primeras 2 ventas por DM. No fue viral, fue intencional.',
  highlight: 'No fue viral, fue intencional.'
}, {
  initials: 'DC',
  name: 'Daniel C.',
  context: 'Coach de finanzas personales',
  quote: 'Me daba pena vender. Los puentes a oferta me cambiaron la cabeza: ahora mis seguidores me piden el link antes de que yo lo comparta.',
  highlight: 'me piden el link antes de que yo lo comparta.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  context: 'Diseñadora freelance',
  quote: 'Dejé de improvisar. Con el calendario y los prompts atómicos publico 4 veces por semana sin quemarme. Ya tengo un flujo constante de clientes por Instagram.',
  highlight: 'publico 4 veces por semana sin quemarme.'
}, {
  initials: 'AM',
  name: 'Andrés Mendoza',
  context: 'Marketer Digital',
  quote: 'Antes publicaba 7 veces a la semana y no vendía nada. Ahora publico 4 y genero ingresos cada semana. Dejé de crear contenido "bonito" y empecé a crear contenido que convierte.',
  highlight: 'genero ingresos cada semana.'
}];
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.5,
      ease: 'easeOut'
    }
  })
};
export function Testimonials() {
  return <Section className="bg-[#0a0a0a]" data-id="element-317">
      <div className="text-center mb-8" data-id="element-318">
        <p className="text-[#14b8a6] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-319">
          Resultados reales
        </p>
        <h2 className="text-2xl md:text-3xl font-black text-white" data-id="element-320">
          Lo que dicen quienes ya lo aplican
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-4" data-id="element-321">
        {testimonials.map((t, i) => <motion.div key={i} custom={i} variants={cardVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className="bg-white border border-gray-200 p-4 flex flex-col justify-between relative" data-id="element-322">
            <Quote size={20} className="text-[#14b8a6] opacity-60 mb-2" fill="currentColor" data-id="element-323" />

            <p className="text-gray-700 leading-relaxed mb-3 text-sm" data-id="element-324">
              "{t.quote}"
            </p>

            <p className="text-[#14b8a6] text-xs font-semibold mb-3 border-l-2 border-[#14b8a6] pl-2" data-id="element-325">
              {t.highlight}
            </p>

            <div className="flex items-center gap-2 mt-auto pt-3 border-t border-gray-200" data-id="element-326">
              <div className="w-8 h-8 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-xs font-bold text-[#14b8a6]" data-id="element-327">
                {t.initials}
              </div>
              <div data-id="element-328">
                <p className="text-gray-900 font-semibold text-xs" data-id="element-329">{t.name}</p>
                <p className="text-gray-500 text-[10px]" data-id="element-330">{t.context}</p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}